import { render } from "./import-topics-modal.vue?vue&type=template&id=248a7d87"
import script from "./import-topics-modal.vue?vue&type=script&lang=js"
export * from "./import-topics-modal.vue?vue&type=script&lang=js"
script.render = render

export default script